import { getLocalizedCurrentDateTimeIfToday } from "./date.utils";

type ActivatableProduct = {
  activationDate?: string | null;
};

export function setTodayActivationDatesToNowIfToday<T extends ActivatableProduct>(
  products: T[],
  now = new Date()
): T[] {
  return products.map((product) => {
    if (!product.activationDate) {
      return product;
    }

    const activationDate = getLocalizedCurrentDateTimeIfToday(product.activationDate, now);

    return activationDate === product.activationDate
      ? product
      : { ...product, activationDate };
  });
}